import { jsx as b } from "react/jsx-runtime";
import "react";
import { classNames as r } from "../../utilities/index.js";
const m = ({ error: t, hide: s, children: l, className: e, ...a }) => {
  const o = r({
    "sash-Label text-body-2 font-semibold": !0,
    "text-black": !t,
    "text-red": t,
    "sr-only": s,
    [e]: e
  });
  return /* @__PURE__ */ b(
    "label",
    {
      className: o,
      ...a,
      children: l
    }
  );
}, d = m;
export {
  d as default
};
